import { strings } from '../context/LanguageContext/strings'

const modifiedAreasList = []

export const productsConstants = {
    getManageUpdatesHeadCells: () => [
        {
            key: 'name',
            id: 'name',
            label: strings.PRODUCT_NAME,
            width: '14%',
            sortable: true,
        },
        {
            key: 'slin',
            id: 'slin',
            label: strings.SLIN,
            width: '8%',
            sortable: true,
        },
        {
            key: 'setup',
            id: 'setup',
            label: strings.SETUP,
            width: '12%',
            sortable: true,
        },
        {
            key: 'modified_area',
            id: 'modified_area',
            label: strings.MODIFIED_AREA,
            width: '18%',
            sortable: true,
        },
        {
            key: 'setting_status',
            id: 'setting_status',
            label: strings.SETTING_STATUS,
            width: '12%',
            sortable: true,
        },
        {
            key: 'flag',
            id: 'flag',
            label: strings.FLAG,
            width: '6%',
            sortable: true,
        },
        {
            key: 'visibility',
            id: 'visibility',
            label: strings.QA,
            width: '6%',
            sortable: true,
        },
        {
            key: 'visibility-prod',
            id: 'visibility-prod',
            label: strings.PROD,
            width: '6%',
            sortable: true,
        },
        {
            key: 'images',
            id: 'images',
            label: strings.IMAGES,
            width: '10%',
        },
        {
            key: 'size_value',
            id: 'size_value',
            label: strings.SIZE_VALUE,
            width: '10%',
        },
        {
            key: 'category',
            id: 'category',
            label: strings.MAIN_CATEGORY,
            width: '12%',
            sortable: true,
        },
        {
            key: 'sub_category',
            id: 'sub_category',
            label: strings.SUBCATEGORY,
            width: '12%',
            sortable: true,
        },
        {
            key: 'dynamic_categories',
            id: 'dynamic_categories',
            label: strings.DYNAMIC_CATEGORY,
            width: '14%',
            sortable: true,
        },
        {
            key: 'created_at',
            id: 'created_at',
            label: strings.CREATED,
            width: '12%',
            sortable: true,
        },
    ],
    getProductsHeadCells: () => [
        {
            id: 'slin',
            label: strings.SECTION_ASSORTMENTS_ADD_PRODUCT_SLIN,
            draggable: false,
            width: '8%',
        },
        {
            id: 'upc',
            label: strings.SECTION_ASSORTMENTS_ADD_PRODUCT_UPC,
            draggable: false,
            width: '10%',
        },
        {
            id: 'database_name',
            label: strings.SECTION_ASSORTMENTS_ADD_PRODUCT_DB,
            draggable: false,
            width: '15%',
        },
        {
            id: 'product_name',
            label: strings.SECTION_ASSORTMENTS_ADD_PRODUCT_NAME,
            draggable: false,
            width: '20%',
        },
        {
            id: 'action',
            label: strings.SECTION_ASSORTMENTS_ADD_PRODUCT_ACTION,
            draggable: false,
            width: '8%',
            align: 'center',
        },
    ],
    productSectionTitles: {
        product_info: 1,
        id_slin: 1,
        categories_filters: 1,
        services_marketplaces: 1,
        pricing: 1,
        status_and_rules: 1,
        name: 1,
    },
    getProductDetailSections: () => [
        { step: 1, key: 'product_info', title: strings.PRODUCT_INFORMATION },
        { step: 2, key: 'id_slin', title: strings.IDS_SLINS },
        { step: 3, key: 'categories_filters', title: strings.CATEGORIES_FILTERS },
        { step: 4, key: 'status_and_rules', title: strings.ONLINE_STATUS_RULES },
        { step: 5, key: 'services_marketplaces', title: strings.SERVICES_MARKETPLACES },
        { step: 6, key: 'pricing', title: strings.PRICING },
    ],
    getFlavourTypes: () => [
        { value: 'Blank', display: strings.BLANK },
        { value: 'Salted Caramel', display: strings.SALTED_CARAMEL },
        { value: 'Fusion', display: strings.FUSION },
        { value: 'Dusk to Dawn Orange Mocha Latte', display: strings.DUSK_TO_DAWN },
        { value: 'Mountain Dew Gamers Arena', display: strings.MOUNTAIN_DEW },
        { value: 'Sprite', display: strings.SPRITE },
        { value: 'Pepsi', display: strings.PEPSI },
        { value: 'Mt Dew', display: strings.MT_DEW },
        { value: 'Jarritos Mandarin', display: strings.JARRITOS },
        { value: 'Dr Pepper', display: strings.DR_PEPPER },
        { value: 'Diet Pepsi', display: strings.DIET_PEPSI },
        { value: 'Diet Dr Pepper', display: strings.DIET_DR_PEPPER },
        { value: 'Diet Coke', display: strings.DIET_COKE },
        { value: 'Coke', display: strings.COKE },
        { value: 'Cherry', display: strings.CHERRY },
        { value: 'Blue Raspberry', display: strings.BLUE_RASPBERRY },
        { value: 'Chocolate Chunk', display: strings.CHOCOLATE_CHUNK },
        { value: 'Brisk Blackberry Smash', display: strings.BRISK_BLACKBERRY },
        { value: 'Columbian', display: strings.COLUMBIAN },
        { value: 'Exclusive Blend', display: strings.EXCLUSIVE_BLEND },
        { value: 'Thawed Taquito', display: strings.THAWED_TAQUITO },
        { value: 'Peeps Latte', display: strings.PEEPS_LATTE },
        { value: 'Cleanse', display: strings.CLEANSE },
        { value: 'Vanilla', display: strings.VANILLA },
        { value: 'Mocha', display: strings.MOCHA },
        { value: 'Cold Brew Black', display: strings.COLD_BREW_BLACK },
        { value: 'Thawed Tenders', display: strings.THAWED_TENDERS },
        { value: 'Sweet Red Chili', display: strings.SWEET_RED_CHILI },
        { value: 'Hot', display: strings.HOT },
        { value: 'Thawed Wings', display: strings.THAWED_WINGS },
        { value: 'Hot Wings', display: strings.HOT_WINGS },
        { value: 'Thawed Buffalo Wings', display: strings.THAWED_BUFFALO_WINGS },
        { value: 'Hot Taquito', display: strings.HOT_TAQUITO },
        { value: 'Thawed Spicy Wings', display: strings.THAWED_SPICY_WINGS },
        { value: 'Honey BBQ', display: strings.HONEY_BBQ },
        { value: 'Roasted', display: strings.ROASTED },
        { value: 'Hot Pizza', display: strings.HOT_PIZZA },
        { value: 'Thawed Pizza', display: strings.THAWED_PIZZA },
        { value: 'Peanut Butter', display: strings.PEANUT_BUTTER },
        { value: 'Oatmeal Raisin', display: strings.OATMEAL_RAISIN },
        { value: 'Hot Tenders', display: strings.HOT_TENDERS },
        { value: 'Chocolate Chip', display: strings.CHOCOLATE_CHIP },
        { value: 'Lemon Poppy Seed', display: strings.LEMON_POPPY_SEED },
        { value: 'Delight', display: strings.DELIGHT },
        { value: 'Exhilerate', display: strings.EXHILERATE },
        { value: 'Serenity', display: strings.SERENITY },
        { value: 'Balance', display: strings.BALANCE },
        { value: 'Bliss', display: strings.BLISS },
        { value: 'Pumpkin Spice Latte', display: strings.PUMPKIN_SPICE_LATTE },
        { value: 'Pumpkin Spice', display: strings.PUMPKIN_SPICE },
        { value: 'Candy Cane', display: strings.CANDY_CANE },
    ],
    getAlcoholCategories: () => [
        { value: 'beer', display: strings.BEER },
        { value: 'wine', display: strings.WINE },
        { value: 'liquor', display: strings.LIQUOR },
    ],
    getMetaTagsCategories: () => [
        { value: 'beer', display: strings.BEER },
        { value: 'wine', display: strings.WINE },
        { value: 'liquor', display: strings.LIQUOR },
        { value: 'alcohol', display: strings.ALCOHOL },
        { value: 'tobacco', display: strings.TOBACCO },
    ],
    getOnlineStatusMetaTagsList: () => [
        {
            value: 'alcohol',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.alcohol,
        },
        {
            value: 'all_high_abv',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.all_high_abv,
        },
        {
            value: 'beer',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.beer,
        },
        {
            value: 'frito_icheck',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.frito_icheck,
        },
        {
            value: 'liquor',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.liquor,
        },
        {
            value: 'whole_pizza',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.whole_pizza,
        },
        {
            value: 'wine',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.wine,
        },
        {
            value: 'CA_ONLY',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.ca_only,
        },
        {
            value: 'Gulp_Foam',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.gulp_foam,
        },
        {
            value: 'Slurpee_stayC',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.slurpee_stayc,
        },
        {
            value: 'cookieplatter_enable',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.cookieplatter_enable,
        },
        {
            value: 'single',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.single,
        },
        {
            value: 'sip_snacks_include',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.sip_snacks_include,
        },
        {
            value: 'tobacco',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.tobacco,
        },
        {
            value: 'vrcafe_menu',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.vrcafe_menu,
        },
        {
            value: 'wing_sauce',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.wing_sauce,
        },
        {
            value: 'cheetos_ignore',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.cheetos_ignore,
        },
        {
            value: 'ny_nj_ma_exclude_chestershot',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.ny_nj_ma_exclude_chestershot,
        },
        {
            value: 'chesters_ignore',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.chesters_ignore,
        },
        {
            value: 'bonein_pdienable',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.bonein_pdienable,
        },
        {
            value: 'boneless_pdienable',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.boneless_pdienable,
        },
        {
            value: 'minitacos_pdienable',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.minitacos_pdienable,
        },
        {
            value: 'pizza_pdienable',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.pizza_pdienable,
        },
        {
            value: 'waterpack_disable',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.waterpack_disable,
        },
        {
            value: 'abv_over_51',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.abv_over_51,
        },
        {
            value: 'abv_under_51',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.abv_under_51,
        },
        {
            value: 'activate_foam_cup',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.activate_foam_cup,
        },
        {
            value: 'deactivate_plastic_cup',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.deactivate_plastic_cup,
        },
        {
            value: 'Gulp_Inactive',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.gulp_inactive,
        },
        {
            value: 'ecig',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.ecig,
        },
        {
            value: 'rosebear_enable',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.rosebear_enable,
        },
        {
            value: 'under_750',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.under_750,
        },
        {
            value: 'biggulp_pdienable',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.biggulp_pdienable,
        },
        {
            value: 'coffee_pdienable',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.coffee_pdienable,
        },
        {
            value: 'grill_pdienable',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.grill_pdienable,
        },
        {
            value: 'menthol_inactive',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.menthol_inactive,
        },
        {
            value: 'slurpee_pdienable',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.slurpee_pdienable,
        },
        {
            value: 'cheetos_ignore_nc_pa_va',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.cheetos_ignore_nc_pa_va,
        },
        {
            value: 'ny_coffecaddy',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.ny_coffecaddy,
        },
        {
            value: 'cigars',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.cigars,
        },
        {
            value: 'phi_cigs_exclude',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.phi_cigs_exclude,
        },
        {
            value: 'phl_cigs_exclude',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.phl_cigs_exclude,
        },
        {
            value: 'exclude_meat_pizza',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.exclude_meat_pizza,
        },
        {
            value: 'include_cheese_pepperoni',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.include_cheese_pepperoni,
        },
        {
            value: 'exclude_cheese_pepperoni',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.include_cheese_pepperoni,
        },
        {
            value: 'roost_ny',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.roost_ny,
        },
        {
            value: 'newpizza_enable',
            display: strings.SECTION_PRODUCT_PAGE_META_TAGS_LABELS.newpizza_enable,
        },
    ],
    getProductServices: () => [
        { value: 'delivery', display: strings.DELIVERY },
        { value: 'pickup', display: strings.PICKUP },
    ],
    getPriceGroups: () => [
        { value: 'N/A', display: strings.NA },
        { value: 'Medium', display: strings.MEDIUM },
        { value: 'Exclude', display: strings.EXCLUDE },
        { value: 'Low', display: strings.LOW },
        { value: 'High', display: strings.HIGH },
        { value: 'Marketplace', display: strings.MARKETPLACE },
        { value: 'Liquor', display: strings.LIQUOR },
        { value: 'Beer', display: strings.BEER },
        { value: 'Wine', display: strings.WINE },
        { value: 'Premium_ice_cream', display: strings.PREMIUM_ICECREAM },
        { value: 'Soda', display: strings.SODA },
    ],
    getPriceGrpName: () => [
        { value: 'N/A', display: strings.NA },
        { value: 'Exclude / Pre-Priced', display: strings.EXCLUDE },
        { value: 'Water-Gallon', display: strings.WATER_GALLON },
        { value: 'Household', display: strings.HOUSEHOLD },
        { value: 'Antacid', display: strings.ANTACID },
        { value: 'Dry Beverages', display: strings.DRY_BEVERAGES },
        { value: 'Chips-Single Serve', display: strings.CHIPS_SINGLE_SERVE },
        { value: 'Ice Cream', display: strings.ICE_CREAM },
        { value: 'Dairy-By Product', display: strings.DAIRY_BY_PRODUCT },
        { value: 'Condiments', display: strings.CONDIMENTS },
        { value: 'Candy-Bags', display: strings.CANDY_BAGS },
        { value: 'Pain Reliever', display: strings.PAIN_RELIEVER },
        { value: 'Sports Drink', display: strings.SPORTS_DRINK },
        { value: 'Water-Single', display: strings.WATER_SINGLE },
        { value: 'Sparkling Water-Single', display: strings.SPARKLING_WATER_SINGLE },
        { value: 'Soft Drinks-Single', display: strings.SOFT_DRINKS_SINGLE },
        { value: 'Tea', display: strings.TEA },
        { value: 'Juice', display: strings.JUICE },
        { value: 'Hot Coffee', display: strings.HOT_COFFEE },
        { value: 'Slurpee', display: strings.SLURPEE },
        { value: 'Big Gulp', display: strings.BIG_GULP },
        { value: 'Cookies-Single Serve', display: strings.COOKIES_SINGLE_SERVE },
        { value: 'Single Beer', display: strings.SINGLE_BEER },
        { value: 'Wine-Single', display: strings.WINE_SINGLE },
        { value: 'Domestic Beer-6pk', display: strings.DOMESTIC_BEER_6PK },
        { value: 'Import Beer-6pk', display: strings.IMPORT_BEER_6PK },
        { value: 'Domestic Beer-12pk', display: strings.DOMESTIC_BEER_12PK },
        { value: 'Domestic Beer-18pk', display: strings.DOMESTIC_BEER_18PK },
        { value: 'Domestic Beer-24pk', display: strings.DOMESTIC_BEER_14PK },
        { value: 'Craft Beer-6pk', display: strings.CRAFT_BEER_6PK },
        { value: 'Liquor', display: strings.LIQUOR },
        { value: 'Pretzels', display: strings.PRETZELS },
        { value: 'Wine-4pk', display: strings.WINE_4PK },
        { value: 'Malt Beer- Single', display: strings.MALT_BEER_SINGLE },
        { value: 'Import Beer-18pk', display: strings.IMPORT_BEER_18PK },
        { value: 'Malt Beer- 30pk', display: strings.MALT_BEER_30PK },
        { value: 'Import Beer-12pk', display: strings.IMPORT_BEER_12PK },
        { value: 'Malt Beer- 15pk', display: strings.MALT_BEER_15PK },
        { value: 'Crackers-Single Serve', display: strings.CRACKERS_SINGLE_SERVE },
        { value: 'Domestic Beer-Bottle', display: strings.DOMESTIC_BEER_BOTTLE },
        { value: 'Malt Beer- 6pk', display: strings.MALT_BEER_6PK },
        { value: 'Craft Beer-4pk', display: strings.CRAFT_BEER_4PK },
        { value: 'Domestic Beer-8pk', display: strings.DOMESTIC_BEER_8PK },
        { value: 'Milk-Take Home', display: strings.MILK_TAKE_HOME },
        { value: 'Chips-Take Home', display: strings.CHIPS_TAKE_HOME },
        { value: 'Domestic-Beer-30pk', display: strings.DOMESTIC_BEER_30PK },
        { value: 'Import Beer-24pk', display: strings.IMPORT_BEER_24PK },
        { value: 'Yogurt', display: strings.YOGURT },
        { value: 'Fresh Vegetable', display: strings.FRESH_VEGETABLE },
        { value: 'Craft Beer-3pk', display: strings.CRAFT_BEER_3PK },
        { value: 'Candy-Single', display: strings.CANDY_SINGLE },
        { value: 'Domestic Beer-9pk', display: strings.DOMESTIC_BEER_9PK },
        { value: 'Candy-Gum', display: strings.CANDY_GUM },
        { value: 'Milk-Single', display: strings.MILK_SINGLE },
        { value: 'Packaged Bakery', display: strings.PACKAGED_BAKERY },
        { value: 'Import Beer-3pk', display: strings.IMPORT_BEER_3PK },
        { value: 'Domestic Beer-30pk', display: strings.DOMESTIC_BEER_30PK },
        { value: 'Malt Beer-12pk', display: strings.MALT_BEER_12PK },
        { value: 'Health', display: strings.HEALTH },
        { value: 'Functional', display: strings.FUNCTIONAL },
        { value: 'Fast Food', display: strings.FAST_FOOD },
        { value: 'Craft Beer-18pk', display: strings.CRAFT_BEER_18PK },
        { value: 'Energy Shots', display: strings.ENERGY_SHOTS },
        { value: 'Veggie/Fruit Snacks', display: strings.VEGGIE_FRUIT_SNACKS },
        { value: 'Energy', display: strings.ENERGY },
        { value: 'Craft Beer-15pk', display: strings.CRAFT_BEER_15PK },
        { value: 'Popcorn', display: strings.POPCORN },
        { value: 'Cold Snacks', display: strings.COLD_SNACKS },
        { value: 'Cookies-Take Home', display: strings.COOKIES_TAKE_HOME },
        { value: 'Cold Coffee', display: strings.COLD_COFFEE },
        { value: 'Wine-2pk', display: strings.WINE_2PK },
        { value: 'Malt Beer- 3pk', display: strings.MALT_BEER_3PK },
        { value: 'single-beer', display: strings.SINGLE_BEER },
        { value: 'Candy-Mints', display: strings.Candy_Mints },
        { value: 'Crackers-Take Home', display: strings.CRACKERS_TAKE_HOME },
        { value: 'CBD', display: strings.CBD },
        { value: 'Cold & Flu', display: strings.COLD_FLU },
        { value: 'Chillers', display: strings.CHILLERS },
        { value: 'Candy-Novelty', display: strings.CANDY_NOVELTY },
        { value: 'medium', display: strings.MEDIUM },
        { value: 'Candy-Mint', display: strings.CANDY_MINT },
        { value: 'premium_ice_cream', display: strings.PREMIUM_ICECREAM },
        { value: 'Lunch Pack', display: strings.LUNCH_PACK },
        { value: 'Electronics', display: strings.ELECTRONICS },
        { value: 'Ice', display: strings.ICE },
        { value: 'Chicken Wings', display: strings.CHICKEN_WINGS },
        { value: 'Whole Pizza', display: strings.WHOLE_PIZZA },
        { value: 'Bread', display: strings.BREAD },
        { value: 'Grocery-On the Go', display: strings.GROCERY_ON_THE_GO },
        { value: 'Fresh Fruit', display: strings.FRESH_FRUIT },
        { value: 'Fresh Bakery', display: strings.FRESH_BAKERY },
        { value: 'Table Settings', display: strings.TABLE_SETTINGS },
        { value: 'Skin Care', display: strings.SKIN_CARE },
        { value: 'Sparkling Water-8pk', display: strings.Sparkling_Water_8pk },
        { value: 'Cosmetics', display: strings.COSMETICS },
        { value: 'Other', display: strings.OTHER },
        { value: 'Water-24pk', display: strings.WATER_24PK },
        { value: 'Take Home', display: strings.TAKE_HOME },
        { value: 'Cooling', display: strings.COOLING },
        { value: 'Pet Food', display: strings.Pet_Food },
        { value: 'Flavored Water-Single', display: strings.FLAVORED_WATER_SINGLE },
        { value: 'Toys', display: strings.TOYS },
        { value: 'Supplements', display: strings.SUPPLEMENTS },
        { value: 'Pet Supplies', display: strings.PET_SUPPLIES },
        { value: 'Hair Care', display: strings.HAIR_CARE },
        { value: 'Deli', display: strings.DELI },
        { value: 'Soft Drinks-2L', display: strings.SOFT_DRINKS_2L },
        { value: 'Grooming', display: strings.GROOMING },
        { value: 'Personal Care', display: strings.PERSONAL_CARE },
        { value: 'Baby Care', display: strings.BABY_CARE },
        { value: 'Water-28pk', display: strings.WATER_28PK },
        { value: 'Anti-Diarrheal', display: strings.ANTI_DIARRHEAL },
        { value: 'Cough Drops', display: strings.COUGH_DROPS },
        { value: 'Oral Care', display: strings.ORAL_CARE },
        { value: 'Anti-Perspirant', display: strings.ANTI_PERSPIRANT },
        { value: 'Laxative', display: strings.LAXATIVE },
        { value: 'Snack Dips', display: strings.SNACK_DIPS },
        { value: 'Snack Mix', display: strings.SNACK_MIX },
        { value: 'Battery', display: strings.BATTERY },
        { value: 'Water - 6pk', display: strings.WATER_6PK },
        { value: 'Soft Drinks', display: strings.SOFT_DRINKS },
        { value: 'Cereal Bar', display: strings.CEREAL_BAR },
        { value: 'Stationery', display: strings.STATIONERY },
    ],
    manageUpdateFilterByOptions: [],
    getManageUpdateTypeOptions: () => [strings.NEW_ITEMS_ONLY, strings.MODIFIED_ITEMS_ONLY],
    getManageUpdateTimeFrameOptions: () => [
        { value: 'Today', display: strings.TODAY },
        { value: 'This week', display: strings.THIS_WEEK },
        { value: 'Last 7 Days', display: strings.LAST_7_DAYS },
        { value: 'This month', display: strings.THIS_MONTH },
        { value: 'Customized Dates', display: strings.CUSTOMIZED_DATES },
    ],
    getSetupFields: () => ({
        [strings.NOT_STARTED]: 'not_started',
        [strings.COMPLETE]: 'complete',
        [strings.INCOMPLETE]: 'incomplete',
    }),
    updateFields: {
        'Not started': 'not_started',
        Saved: 'saved',
        Incomplete: 'incomplete',
    },
    getSettingStatusFields: () => [
        { value: 'active', display: strings.ACTIVE },
        { value: 'inactive', display: strings.INACTIVE },
        { value: 'scheduled', display: strings.SCHEDULED },
    ],
    getFlagFields: () => [
        { value: 'On', display: strings.ON },
        { value: 'Off', display: strings.OFF },
    ],
    getVisibilityFields: () => ({
        [strings.DRAFT]: 'none',
        [strings.QA]: 'qa',
        [strings.PROD]: 'prod',
    }),
    getProductImageFields: () => [
        { value: 'Included', display: strings.INCLUDED },
        { value: 'No image available', display: strings.NO_IMAGE_AVAILABLE },
    ],
    getRecentUpdatedFields: () => [
        { value: 'Added', display: strings.ADDED },
        { value: 'Modified', display: strings.SECTION_PRODUCT_PAGE_TABLE_MODIFIED },
    ],
    productSetupStatuses: {
        NOT_STARTED: 'not_started',
        INCOMPLETE: 'incomplete',
        COMPLETE: 'complete',
        MODIFIED: 'modified',
    },
    productStatuses: {
        IMPORTED: 'imported',
        DRAFT: 'draft',
        PUBLISHED: 'published',
    },
    productVisibilities: {
        NONE: 'none',
        QA: 'qa',
        PROD: 'prod',
    },
    productOnlineStatuses: {
        ACTIVE: 'active',
        INACTIVE: 'inactive',
        SCHEDULED: 'scheduled',
    },
    getCatalogTypeOptions: () => [
        {
            label: strings.USA,
            options: [
                { label: strings.RIS, value: '7now' },
                { label: strings.PDI, value: 'horizon' },
            ],
        },
    ],
    getManageProductsHeadCells: () => [
        {
            key: 'name',
            id: 'name',
            label: strings.SECTION_PRODUCT_PAGE_TABLE_PRODUCT_NAME,
            width: '14%',
            sortable: true,
        },
        {
            key: 'slin',
            id: 'slin',
            label: strings.SECTION_PRODUCT_PAGE_TABLE_SLIN,
            width: '8%',
            sortable: true,
        },
        {
            key: 'upc',
            id: 'upc',
            label: strings.SECTION_PRODUCT_PAGE_TABLE_UPC,
            width: '12%',
        },
        {
            key: 'flag',
            id: 'flag',
            label: strings.FLAG,
            width: '8%',
            sortable: true,
        },
        {
            key: 'online_status',
            id: 'online_status',
            label: strings.SECTION_PRODUCT_PAGE_TABLE_STATUS,
            width: '12%',
            sortable: true,
        },
        {
            key: 'online_status_scheduled',
            id: 'online_status_scheduled',
            label: strings.SECTION_PRODUCT_PAGE_TABLE_SCHEDULE,
            width: '14%',
            sortable: true,
        },
        {
            key: 'images',
            id: 'images',
            label: strings.SECTION_PRODUCT_PAGE_TABLE_IMAGES,
            width: '16%',
        },
        {
            key: 'size_value',
            id: 'size_value',
            label: strings.SECTION_PRODUCT_PAGE_TABLE_SIZE_VALUE,
            width: '10%',
        },
        {
            key: 'category_name',
            id: 'category_name',
            label: strings.MAIN_CATEGORY,
            width: '12%',
            sortable: true,
        },
        {
            key: 'sub_category_name',
            id: 'sub_category_name',
            label: strings.SUBCATEGORY,
            width: '12%',
            sortable: true,
        },
        {
            key: 'meta_tags',
            id: 'meta_tags',
            label: strings.SECTION_PRODUCT_PAGE_TABLE_META_TAGS,
            width: '12%',
        },
        {
            key: 'updated_at',
            id: 'updated_at',
            label: strings.SECTION_PRODUCT_PAGE_TABLE_MODIFIED,
            width: '14%',
            sortable: true,
        },
        {
            key: 'created_at',
            id: 'created_at',
            label: strings.SECTION_PRODUCT_PAGE_TABLE_CREATED,
            width: '14%',
            sortable: true,
        },
    ],
    setModifiedAreasList: list => {
        modifiedAreasList.splice(0, modifiedAreasList.length)
        Object.assign(modifiedAreasList, list)
    },
    getModifiedAreasList: () => {
        return modifiedAreasList
    },
    getHandlings: () => [
        { value: 'hot', name: strings.HOT },
        { value: 'cold', name: strings.COLD },
    ],
}
